const commonEventProperties = ['pageName', 'pageSection', 'pageStage', 'pageDept', 'pageSegmentation'];
const tenants = {
    Vistaprint: 'vistaprint',
    VCS: 'vcs',
    VistaprintPro: 'vistaprintpro',
    ProShop: 'proshop',
    NationalPen: 'national-pen'
};
const vcsTenants = new Set([tenants.VCS, tenants.VistaprintPro, tenants.ProShop]);

module.exports = {
    commonEventProperties,
    tenants,
    vcsTenants
};
